function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 8a8 8 0 1016 0A8 8 0 000 8zm8-5a1 1 0 011 1v3.465l2.555 1.703a1 1 0 01-1.11 1.664l-3-2A1 1 0 017 8V4a1 1 0 011-1z",
  fill: "#243143"
});

function SvgClock16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wIDhDMCAxMi40MTgzIDMuNTgxNzIgMTYgOCAxNkMxMi40MTgzIDE2IDE2IDEyLjQxODMgMTYgOEMxNiAzLjU4MTcyIDEyLjQxODMgMCA4IDBDMy41ODE3MiAwIDAgMy41ODE3MiAwIDhaTTggM0M4LjU1MjI5IDMgOSAzLjQ0NzcyIDkgNFY3LjQ2NDgyTDExLjU1NDcgOS4xNjc5NUMxMi4wMTQyIDkuNDc0MyAxMi4xMzg0IDEwLjA5NTIgMTEuODMyMSAxMC41NTQ3QzExLjUyNTcgMTEuMDE0MiAxMC45MDQ4IDExLjEzODQgMTAuNDQ1MyAxMC44MzIxTDcuNDQ1MyA4LjgzMjA1QzcuMTY3MSA4LjY0NjU4IDcgOC4zMzQzNSA3IDhWNEM3IDMuNDQ3NzIgNy40NDc3MiAzIDggM1oiIGZpbGw9IiMyNDMxNDMiLz4KPC9zdmc+Cg==";
export { SvgClock16 as ReactComponent };